import { selectIsCartOpen } from '@entities/cart';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import { ShoppingCartMobile } from '@shared/assets/icons';
import { useAppSelector } from '@shared/hooks';
import * as st from './styles.module.scss';

interface Props {
  hideMenu?: () => void;
}

export const ButtonCart: React.FC<Props> = ({ hideMenu }) => {
  // const dispatch = useAppDispatch();
  // const items = useAppSelector(selectCartItems);
  const isCartOpen = useAppSelector(selectIsCartOpen);

  const onCartClick = () => {
    // dispatch(openCart());
    hideMenu && hideMenu();
  };

  return (
    <NavLink to="/cart/">
      <div className={cn(st.button, isCartOpen && st.active)} onClick={onCartClick}>
        <ShoppingCartMobile />
      </div>
    </NavLink>
  );
};
